import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import MapView from './map-view';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query RepVisitsSearchMapView($hsId: String!) {
    viewer {
      id
      repVisitHighSchoolsWithinProximity(id: $hsId, numSchoolsWithinProximity: 10, distance: "30mi") {
        toSchool {
          id
          name
          repVisitsAccount {
            id
            supportsRepVisits
            supportsCollegeFairs
          }
          address {
            field_hs_elna_location_latlon {
              latitude
              longitude
            }
          }
        }
      }
      nonRepVisitHighSchoolsWithinProximity(id: $hsId, numSchoolsWithinProximity: 10, distance: "30mi") {
        toSchool {
          id
          name
          repVisitsAccount {
            id
            supportsRepVisits
            supportsCollegeFairs
          }
          address {
            field_hs_elna_location_latlon {
              latitude
              longitude
            }
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ hsId }) => ({
    variables: {
      hsId,
    },
  }),
});

export default SimpleLoadingComponent(graphqlData)(MapView);
